(function(){
  'use strict';

  var header=document.querySelector('[data-nn-header]');
  function setHeader(){
    if(header)header.classList.toggle('is-scrolled',window.scrollY>24);
  }

  function announce(message){
    var region=document.querySelector('[data-nn-live]');
    if(!region)return;
    region.textContent='';
    window.setTimeout(function(){region.textContent=message;},20);
  }

  function responseJSON(response){
    return response.text().then(function(text){
      var data={};
      if(text){
        try{data=JSON.parse(text);}catch(error){data={description:text};}
      }
      if(!response.ok||data.status>=400){
        throw new Error(data.description||data.message||'The cart could not be updated.');
      }
      return data;
    });
  }

  function localizedCartAdd(item){
    var root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
    var url=root.replace(/\/?$/,'/')+'cart/add.js';
    return fetch(url,{
      method:'POST',
      credentials:'same-origin',
      headers:{'Accept':'application/json','Content-Type':'application/json'},
      body:JSON.stringify({items:[item]})
    }).then(responseJSON);
  }

  setHeader();
  window.addEventListener('scroll',setHeader,{passive:true});

  document.addEventListener('click',function(event){
    var cartLink=event.target.closest('[data-nn-cart-open]');
    if(cartLink&&window.NNCart&&window.NNCart.open){
      event.preventDefault();
      if(window.NNMenu&&window.NNMenu.close)window.NNMenu.close(false);
      window.NNCart.open(cartLink);
      return;
    }

    var addButton=event.target.closest('[data-nn-quick-add]');
    if(!addButton)return;
    event.preventDefault();

    var variantId=(addButton.getAttribute('data-variant-id')||'').trim();
    var sellingPlanId=(addButton.getAttribute('data-selling-plan-id')||'').trim();
    var variantNumber=Number(variantId);
    var sellingPlanNumber=Number(sellingPlanId);
    if(!/^\d+$/.test(variantId)||!Number.isSafeInteger(variantNumber)||variantNumber<=0){
      announce('This product option is unavailable.');
      return;
    }

    var original=addButton.innerHTML;
    var item={id:variantNumber,quantity:1};
    if(/^\d+$/.test(sellingPlanId)&&Number.isSafeInteger(sellingPlanNumber)&&sellingPlanNumber>0)item.selling_plan=sellingPlanNumber;
    addButton.disabled=true;
    addButton.setAttribute('aria-busy','true');
    addButton.textContent='Adding...';

    var drawerHandlesAdd=Boolean(window.NNCart&&window.NNCart.add);
    var request=drawerHandlesAdd?window.NNCart.add(item,addButton):localizedCartAdd(item);
    Promise.resolve(request).then(function(result){
      if(result&&result.ok===false)throw new Error(result.message||'The item could not be added.');
      addButton.textContent='Added';
      announce('Item added to cart.');
      if(!drawerHandlesAdd&&window.NNCart&&window.NNCart.open)window.NNCart.open(addButton);
    }).catch(function(error){
      addButton.textContent='Try again';
      announce(error&&error.message?error.message:'The item could not be added. Please try again.');
    }).then(function(){
      window.setTimeout(function(){
        addButton.disabled=false;
        addButton.removeAttribute('aria-busy');
        addButton.innerHTML=original;
      },1500);
    });
  });

  var video=document.querySelector('[data-nn-hero-video]');
  var videoToggle=document.querySelector('[data-nn-video-toggle]');
  if(video&&videoToggle){
    var reduceMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function syncVideoToggle(){
      var isPaused=video.paused;
      videoToggle.innerHTML=isPaused?'<span aria-hidden="true">&#9654;</span>':'<span aria-hidden="true">II</span>';
      videoToggle.setAttribute('aria-label',isPaused?'Play background video':'Pause background video');
    }
    video.addEventListener('play',syncVideoToggle);
    video.addEventListener('pause',syncVideoToggle);
    if(reduceMotion){
      video.removeAttribute('autoplay');
      video.pause();
      syncVideoToggle();
    }else{
      var autoplayRequest=video.play();
      if(autoplayRequest&&autoplayRequest.catch)autoplayRequest.catch(syncVideoToggle);
      syncVideoToggle();
    }
    videoToggle.addEventListener('click',function(){
      if(video.paused){
        var playRequest=video.play();
        if(playRequest&&playRequest.catch)playRequest.catch(function(){syncVideoToggle();announce('The background video could not be played.');});
      }else{
        video.pause();
      }
    });
  }

  function initArsenal(rail){
    if(!rail||rail.dataset.nnArsenalReady==='true')return;
    rail.dataset.nnArsenalReady='true';
    var track=rail.querySelector('[data-nn-arsenal-track]');
    var cards=Array.prototype.slice.call(rail.querySelectorAll('[data-nn-arsenal-card]'));
    var previous=rail.querySelector('[data-nn-arsenal-prev]');
    var next=rail.querySelector('[data-nn-arsenal-next]');
    var progress=rail.querySelector('[data-nn-arsenal-progress]');
    var count=rail.querySelector('[data-nn-arsenal-count]');
    var activeIndex=0;
    var frame=null;
    if(!track||!cards.length)return;

    function twoDigits(value){return value<10?'0'+value:String(value);}
    function setActive(index){
      activeIndex=Math.max(0,Math.min(cards.length-1,index));
      cards.forEach(function(card,cardIndex){
        var isActive=cardIndex===activeIndex;
        card.classList.toggle('is-active',isActive);
        card.setAttribute('aria-current',isActive?'true':'false');
      });
      if(previous)previous.disabled=activeIndex===0;
      if(next)next.disabled=activeIndex===cards.length-1;
      if(progress)progress.style.width=((activeIndex+1)/cards.length*100)+'%';
      if(count)count.textContent=twoDigits(activeIndex+1)+' / '+twoDigits(cards.length);
    }

    function closestCard(){
      var trackLeft=track.getBoundingClientRect().left;
      var bestIndex=0;
      var bestDistance=Infinity;
      cards.forEach(function(card,index){
        var distance=Math.abs(card.getBoundingClientRect().left-trackLeft);
        if(distance<bestDistance){bestDistance=distance;bestIndex=index;}
      });
      setActive(bestIndex);
    }

    function go(index){
      var target=cards[Math.max(0,Math.min(cards.length-1,index))];
      if(!target)return;
      target.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'nearest',inline:'start'});
    }

    track.addEventListener('scroll',function(){
      if(frame)window.cancelAnimationFrame(frame);
      frame=window.requestAnimationFrame(closestCard);
    },{passive:true});
    track.addEventListener('keydown',function(event){
      if(event.key==='ArrowRight'){event.preventDefault();go(activeIndex+1);}
      if(event.key==='ArrowLeft'){event.preventDefault();go(activeIndex-1);}
    });
    if(previous)previous.addEventListener('click',function(){go(activeIndex-1);});
    if(next)next.addEventListener('click',function(){go(activeIndex+1);});
    rail.addEventListener('click',function(event){
      var select=event.target.closest('[data-nn-arsenal-select]');
      if(!select)return;
      var card=select.closest('[data-nn-arsenal-card]');
      var index=cards.indexOf(card);
      if(index>-1){setActive(index);go(index);}
    });
    setActive(0);
  }

  document.querySelectorAll('[data-nn-arsenal-rail]').forEach(initArsenal);
  document.addEventListener('shopify:section:load',function(event){
    if(event.target.matches&&event.target.matches('[data-nn-arsenal-rail]'))initArsenal(event.target);
    event.target.querySelectorAll&&event.target.querySelectorAll('[data-nn-arsenal-rail]').forEach(initArsenal);
  });
})();
